var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.888,
    height: 14.1,
    viewBox: "0 0 20.888 14.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-email",
    "data-name": "Icon zocial-email",
    d: "M.072,16.919V5.317q0-.02.06-.383l6.828,5.841L.153,17.322a1.707,1.707,0,0,1-.081-.4ZM.978,4.128a.868.868,0,0,1,.342-.06h18.39a1.141,1.141,0,0,1,.363.06L13.225,9.99l-.906.725-1.793,1.47-1.793-1.47L7.827,9.99ZM1,18.108l6.869-6.587,2.659,2.155,2.659-2.155,6.869,6.587a.967.967,0,0,1-.342.06H1.321A.912.912,0,0,1,1,18.108Zm13.093-7.332L20.9,4.934a1.2,1.2,0,0,1,.06.383v11.6a1.544,1.544,0,0,1-.06.4Z",
    transform: "translate(-0.072 -4.068)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialEmail);
export default __webpack_public_path__ + "static/media/social-email.79740979ef40e8c8aa3c458ab6aa059b.svg";
export { ForwardRef as ReactComponent };